import React from 'react';

/**
 * Small extension-driven file-type badge for the project tree's Inputs list.
 *
 * Renders one of: PDF (red), XLS (green), PNG (purple), DOC (blue),
 * URL (grey), HTM (orange), or FILE (grey fallback). Shape + colors are
 * driven entirely by `app-shell.css`'s `.file-badge` rules.
 */

const EXT_KIND = {
  pdf: 'PDF',
  xlsx: 'XLS', xls: 'XLS', csv: 'XLS',
  png: 'PNG', jpg: 'PNG', jpeg: 'PNG', gif: 'PNG', webp: 'PNG', svg: 'PNG',
  doc: 'DOC', docx: 'DOC',
  html: 'HTM', htm: 'HTM',
};

export function fileKindFromName(filenameOrUrl) {
  if (!filenameOrUrl) return 'FILE';
  const s = String(filenameOrUrl);
  if (/^https?:\/\//i.test(s)) return 'URL';
  const dot = s.lastIndexOf('.');
  if (dot < 0) return 'FILE';
  const ext = s.slice(dot + 1).toLowerCase();
  return EXT_KIND[ext] || 'FILE';
}

export default function FileTypeBadge({ name }) {
  const kind = fileKindFromName(name);
  return (
    <span className={`file-badge file-badge-${kind.toLowerCase()}`}>{kind}</span>
  );
}
